import { FunctionComponent } from 'react'
import { useScope } from '~/hooks/useScope'
import { useNodeStaffAccess } from '~/hooks/useNodeStaffAccess'
import { scopeOwnsOffer } from '~/modules/monetization/upgrade/scopeOffers'
import { AdmAdUnitsPage } from '~/modules/adm/inventory/adunits/AdmAdUnitsPage'
import { UpgradeLockedPanel } from '~/modules/monetization/upgrade/UpgradeLockedPanel'
import { AdUnitsPage } from '~/modules/pbs/adunits/AdUnitsPage'
import { AdUnitTab, isTabAvailable } from './adUnitTab'

/**
 * One tab of the Ad units page: the product's own list when the scope owns it, the pitch when it does
 * not. The two lists stay the components they always were — Web reads One's inventory, the other three
 * read Node's, and the models behind them share almost no fields, so merging the tables themselves
 * would be a rewrite with nothing to show for it. What is shared is the page around them.
 */
export const AdUnitsTab: FunctionComponent<{ tab: AdUnitTab }> = ({ tab }) => {
  const scope = useScope()
  const { hasNode } = useNodeStaffAccess()

  if (!isTabAvailable(tab, { hasOne: scopeOwnsOffer(scope, 'one'), hasNode })) {
    return <UpgradeLockedPanel offers={[tab.offer]} />
  }

  return tab.env ? <AdUnitsPage env={tab.env} /> : <AdmAdUnitsPage />
}
